import React from 'react';
import CommandesPeriode from './CommandesPeriode';

// Onglet « Commandes des 7 derniers jours » — délègue au composant générique
// (avant : quasi-duplication à 95% avec ListeCommandeJour).
const ListeCommande7jrs = () => (
  <CommandesPeriode endpoint="commande7" emptyText="Aucune commande sur les 7 derniers jours." />
);

export default ListeCommande7jrs;
